import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './services.css'

const Services = (props) => {
  return (
    <div id={props.servicesId} className="services-container1">
      <span className="services-title">
        {props.serviceTitle ?? (
          <Fragment>
            <span className="services-text16">Services</span>
          </Fragment>
        )}
      </span>
      <div className="services-container2">
        <div className="services-web-container">
          <span className="services-text10">
            {props.titleWeb ?? (
              <Fragment>
                <span className="services-text21">Web development</span>
              </Fragment>
            )}
          </span>
          <img
            alt={props.imageWebAlt}
            src={props.imageSrcWeb}
            className="services-image1"
          />
        </div>
        <div className="services-app-container">
          <span className="services-text11">
            {props.titleApp ?? (
              <Fragment>
                <span className="services-text20">App development</span>
              </Fragment>
            )}
          </span>
          <img
            alt={props.imageAppAlt}
            src={props.imageSrcApp}
            className="services-image2"
          />
        </div>
        <div className="services-dev-ops-container">
          <span className="services-text12">
            {props.titleDevOps ?? (
              <Fragment>
                <span className="services-text22">DevOps</span>
              </Fragment>
            )}
          </span>
          <img
            alt={props.imageDevOpsAlt}
            src={props.imageSrcDevOps}
            className="services-image3"
          />
        </div>
        <div className="services-ds-container">
          <span className="services-text13">
            {props.titleDS ?? (
              <Fragment>
                <span className="services-text17">
                  Data Science &amp; AI Development
                </span>
              </Fragment>
            )}
          </span>
          <img
            alt={props.imageDSAlt}
            src={props.imageSrcDS}
            className="services-image4"
          />
        </div>
        <div className="services-sa-container">
          <span className="services-text14">
            {props.titleSA ?? (
              <Fragment>
                <span className="services-text18">
                  Software &amp; System Architecture
                </span>
              </Fragment>
            )}
          </span>
          <img
            alt={props.imageSAAlt}
            src={props.imageSrcSA}
            className="services-image5"
          />
        </div>
      </div>
      <button
        type="button"
        className="services-button button"
        onClick={() => {
          window.location.href = "mailto:contact@stefanlacher.com?subject=Message from stefanlacher.com&body=I would like to talk about my project.";
        }}
      >
        <span className="services-text15">
          {props.talkProjectButton ?? (
            <span className="services-text19">Let’s talk about your project</span>
          )}
        </span>
      </button>

    </div>
  )
}

Services.defaultProps = {
  imageSrcWeb: '/web-300w.webp',
  serviceTitle: undefined,
  imageAppAlt: 'image',
  titleDS: undefined,
  titleSA: undefined,
  imageDevOpsAlt: 'image',
  talkProjectButton: undefined,
  imageSrcDS: '/ds-300w.webp',
  titleApp: undefined,
  titleWeb: undefined,
  imageDSAlt: 'image',
  titleDevOps: undefined,
  imageSrcDevOps: '/devops-300w.webp',
  servicesId: 'ServicesId',
  imageWebAlt: 'image',
  imageSrcSA: '/sa-300w.webp',
  imageSAAlt: 'image',
  imageSrcApp: '/app-300w.webp',
}

Services.propTypes = {
  imageSrcWeb: PropTypes.string,
  serviceTitle: PropTypes.element,
  imageAppAlt: PropTypes.string,
  titleDS: PropTypes.element,
  titleSA: PropTypes.element,
  imageDevOpsAlt: PropTypes.string,
  talkProjectButton: PropTypes.element,
  imageSrcDS: PropTypes.string,
  titleApp: PropTypes.element,
  titleWeb: PropTypes.element,
  imageDSAlt: PropTypes.string,
  titleDevOps: PropTypes.element,
  imageSrcDevOps: PropTypes.string,
  servicesId: PropTypes.string,
  imageWebAlt: PropTypes.string,
  imageSrcSA: PropTypes.string,
  imageSAAlt: PropTypes.string,
  imageSrcApp: PropTypes.string,
}

export default Services
